"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var W9S_component_1 = require("./W9S.component");
exports.W9S = W9S_component_1.W9S;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9XOVMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxpREFBbUM7QUFBM0IsOEJBQUEsR0FBRyxDQUFBIn0=